import "core-js/modules/es.array.push.js";
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-138e4689"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "launchpad"
};
const _hoisted_2 = {
  class: "launchpad-body"
};
const _hoisted_3 = {
  key: 0,
  class: "launchpad-group",
  style: {
    "margin-top": "40px"
  }
};
const _hoisted_4 = {
  class: "launchpad-group-header"
};
const _hoisted_5 = {
  class: "group-title"
};
const _hoisted_6 = {
  class: "launchpad-group-main"
};
const _hoisted_7 = {
  class: "launchpad-group"
};
const _hoisted_8 = {
  key: 0,
  class: "launchpad-group-header"
};
const _hoisted_9 = {
  class: "group-title"
};
const _hoisted_10 = {
  class: "group-subtitle"
};
const _hoisted_11 = {
  class: "launchpad-group-main"
};
const _hoisted_12 = {
  class: "list-pagination"
};
const _hoisted_13 = ["href"];
import { computed, reactive, watch, onBeforeUnmount } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import pushEvent from '@bfe/by-gtm';
import { lpapi } from '@/apis/spot';
import { error } from '@/utils/toast';
import { saPushEvent } from '@/utils/sensors';
import { SPOT_LAUNCHPAD_HOME_MAJOR_CLICK } from '@/config/sensors';
import SpotSwiper from '@/components/swiper/Swiper';
import { useLaunchpad } from '@/hooks/launchpad';
import { useDeadpool, DEADPOOLKEYS } from '@/hooks/useDeadpool';
import { whiteListManager } from '@/utils/whiteListManager';
import { useUtcTime } from './hooks/utcTime';
import HomeBanner from './components/HomeBannerNew';
import FooterInvitation from './components/FooterInvitation';
import Subscribe from './components/SubscribeNew';
import HomeFAQ from './components/HomeFAQ';
import LaunchpadCard from './components/LaunchpadCard/Card';
export default {
  __name: 'index',
  setup(__props) {
    const {
      locale,
      t
    } = useI18n({
      useScope: 'global'
    });
    const store = useStore();
    const router = useRouter();
    const {
      jumpLink
    } = useLaunchpad();
    const {
      isDeadpoolReady,
      isGray
    } = useDeadpool(DEADPOOLKEYS.launchpadGray);
    const state = reactive({
      loading: true,
      project: {},
      total: undefined,
      diffTime: 0,
      nextProject: undefined,
      historyData: undefined,
      onGoingList: [],
      endList: [],
      onGoingListLoading: false,
      endListLoading: false,
      current: 1,
      headData: undefined
    });
    const pageSize = 3;

    // 页面可见
    const pageShow = computed(() => store.state.settings.pageStatus.show);

    // 添加计算属性来判断列表是否都加载完成
    const listsLoaded = computed(() => !state.onGoingListLoading && !state.endListLoading);
    const timer = null;

    // 获取时间差
    state.diffTime = useUtcTime().diffTime;
    const filterData = data => data.filter(item => {
      let isvalid = true;
      if (!whiteListManager.isInWhiteList(item.currencyName)) {
        isvalid = false;
        return isvalid;
      }
      item.projectActivityList.some(activity => {
        if (!whiteListManager.isInWhiteList(activity.currencyName) || !whiteListManager.isInWhiteList(activity.exchangedCurrencyName)) {
          isvalid = false;
          return isvalid;
        }
        return true;
      });
      return isvalid;
    });
    const getList = async () => {
      try {
        state.onGoingListLoading = true;
        const {
          success,
          result,
          message
        } = await lpapi.getOnGoingList();
        if (success) {
          if (whiteListManager.isNeedFilter()) {
            result.projectList = filterData(result.projectList);
          }
          state.onGoingList = result.projectList || [];
          state.headData = result;
        }
        state.onGoingListLoading = false;
      } catch (e) {
        console.log(e);
        state.onGoingListLoading = false;
      }
    };
    const getEndList = async () => {
      try {
        state.endListLoading = true;
        const {
          success,
          result,
          message
        } = await lpapi.getEndList({
          current: state.current || 1,
          pageSize
        });
        if (success) {
          if (whiteListManager.isNeedFilter()) {
            result.list = filterData(result.list || []);
          }
          state.endList = result?.list || [];
          state.total = result?.total || 0;
        }
        console.log('getEndList:', result);
        state.endListLoading = false;
      } catch (e) {
        console.log(e);
        state.endListLoading = false;
      }
    };
    watch(() => ({
      current: state.current,
      isDeadpoolReady: isDeadpoolReady.value,
      isGray: isGray.value
    }), () => {
      if (!isDeadpoolReady.value || isGray.value) {
        return;
      }
      getEndList();
    }, {
      immediate: true
    });

    // 跳转详情页
    const handleToDetail = name => {
      if (!state.project.code) return;
      saPushEvent(SPOT_LAUNCHPAD_HOME_MAJOR_CLICK, {
        page_name: 'LpadHomePage',
        plate_area: 'OngoingProject',
        project_name: state.project.name,
        button_name: name || ''
      });
      pushEvent('click', 'spot_launchpadlplm', state.project.name);
      router.push(`/${locale.value}/trade/spot/launchdetail/?id=${state.project.code}`);
    };

    // 跳转列表页
    const handleToList = () => {
      saPushEvent(SPOT_LAUNCHPAD_HOME_MAJOR_CLICK, {
        page_name: 'LpadHomePage',
        plate_area: 'OngoingProject',
        project_name: state.project.name,
        button_name: 'LearnMore'
      });
      router.push(`/${locale.value}/trade/spot/launchpad-list`);
    };
    const handleSwiperClick = item => {
      saPushEvent(SPOT_LAUNCHPAD_HOME_MAJOR_CLICK, {
        page_name: 'LpadHomePage',
        plate_area: 'SwiperBanner'
      });
      jumpLink(item);
    };
    if (!window.sfe.prerender) {
      getList();
    }
    watch(() => pageShow.value, val => {
      if (val) {
        getList();
      }
    });
    onBeforeUnmount(() => {
      clearTimeout(timer);
    });
    watch(() => listsLoaded.value, val => {
      if (val) {
        try {
          const el = document.getElementById('placeholder-home');
          el.style.opacity = '0';
          el.style.zIndex = '-999';
          el.style.overflow = 'hidden';
        } catch (e) {
          console.log('error:', e);
        }
      }
    });
    return (_ctx, _cache) => {
      const _component_el_pagination = _resolveComponent("el-pagination");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(HomeBanner), {
        "overview-data": state.headData
      }, null, 8, ["overview-data"]), _createElementVNode("div", _hoisted_2, [state.onGoingList?.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("h3", _hoisted_5, _toDisplayString(_unref(t)('tokenSale')), 1)]), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.onGoingList, item => {
        return _openBlock(), _createBlock(_unref(LaunchpadCard), {
          data: item,
          "diff-time": state.diffTime
        }, null, 8, ["data", "diff-time"]);
      }), 256))])])) : _createCommentVNode("", true), _unref(listsLoaded) ? (_openBlock(), _createBlock(_unref(Subscribe), {
        key: 1
      })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, [state.endList?.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("h3", _hoisted_9, _toDisplayString(_unref(t)('pastPerformance')), 1), _createElementVNode("h4", _hoisted_10, _toDisplayString(_unref(t)('secureEarlyAccess')), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.endList, item => {
        return _openBlock(), _createBlock(_unref(LaunchpadCard), {
          key: item.code,
          data: item,
          "diff-time": state.diffTime
        }, null, 8, ["data", "diff-time"]);
      }), 128))]), _createElementVNode("div", _hoisted_12, [state.total > pageSize ? (_openBlock(), _createBlock(_component_el_pagination, {
        key: 0,
        layout: "prev, pager, next",
        total: state.total,
        "page-size": pageSize,
        "current-page": state.current,
        "onUpdate:current-page": _cache[0] || (_cache[0] = $event => state.current = $event),
        background: true
      }, null, 8, ["total", "current-page"])) : _createCommentVNode("", true)])]), _unref(listsLoaded) ? (_openBlock(), _createBlock(_unref(HomeFAQ), {
        key: 2
      })) : _createCommentVNode("", true), _unref(listsLoaded) ? (_openBlock(), _createElementBlock("a", {
        key: 3,
        href: `/${_unref(locale)}/help-center/bybitHC_SubCategories?language=en_US&id=a005g000031G1Z3AAK&subTopic=Launchpad`,
        class: "btn-faq ts",
        target: "_blank",
        onClick: _cache[1] || (_cache[1] = $event => _unref(saPushEvent)('SpotLpadHomePageFaQClick', {
          page_name: 'LpadHomePage'
        }))
      }, null, 8, _hoisted_13)) : _createCommentVNode("", true)])]);
    };
  }
};